<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="2">
        <span class="font-weight-black">예약자</span>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <span style="cursor: pointer" @click="booker ? $router.push(`/customers/${booker.customerId}`) : ''">{{booker.customerName}}</span>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <span class="font-weight-black">예약 날짜</span>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <span>{{ createdCheck }}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">연락처</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{booker.customerNo}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6" v-if="booker.customer">
        <span class="font-weight-black align-self-center">비상 연락처</span>
      </v-col>
      <v-col cols="12" md="4" sm="6" v-if="booker.customer">
        <span>{{priorityOfContactList}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">용도</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>  {{ booker.usages }}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black align-self-center">수하물</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span> {{ booker.luggage }}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">회원 유형</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        {{booker.customerType ? showCustomerType(booker.customerType) : ''}}
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black align-self-center">비고</span>
      </v-col>
      <v-col cols="12" md="4" sm="6" justify="center">
        {{getEtcInfo(booker)}}
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-row>
      <v-col cols="12" class="font-weight-black">
        동승자 목록
      </v-col>
      <v-col cols="12">
        <c-table :headers="passengerTableHeaders" :items="passengerListItems" hide-default-footer :items-per-page="-1">
          <template #customerType="{item}">
            {{showCustomerType(item.customerType)}}
          </template>
          <template #etc="{item}">
            {{getEtcInfo(item)}}
          </template>
          <template #usages="{item}">
            {{ item.usages }}
          </template>
          <template #luggage="{item}">
            {{ item.luggage }}
          </template>
          <template #detail="{item}">
            <c-btn icon iconName="search" :to="`/customers/${item.customerId}`"></c-btn>
          </template>
        </c-table>
      </v-col>

    </v-row>
    <v-divider></v-divider>

    <v-row>
      <v-col cols="12" md="2" sm="6">
        <span v-if="!canceledFlag" class="font-weight-black">바우처</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span v-if="!canceledFlag">{{ couponInfo }}</span>
      </v-col>
      <v-col cols="12" md="6" sm="6"></v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">출발 시간</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationListData('startTime')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">서비스 종료 시간</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationListData('endTime')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">소요 시간</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationListData('driveTime')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">예약 인원</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{passengerList.length}}</span>
        <span>명</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">도움서비스 시간</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationListData('serviceTime')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">도움 서비스</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <template v-if="this.reservationRouteLists.length && this.reservationRouteLists[0].isUsingHelpService">
          <v-row>병원동행
            <c-btn
              v-if="checkReservationState(reservationRouteLists) !== 'rs_cancel' && checkReservationState(reservationRouteLists) !== 'rs_user_cancel'"
              :disabled="checkReservationState(reservationRouteLists) === 'rs_done'"
              small
              color="blue"
              class="ml-3"
              outlined
              @click="openHelpServiceDialog"
            >
              도움 서비스 정보 입력
            </c-btn>
          </v-row>
          <v-row class="mt-2">{{getReservationListData('isMatching') ? '배정 완료' : '미배정'}} | {{ getReservationListData('managerName')}}</v-row>
        </template>
        <template v-else>
          -
        </template>
      </v-col>


      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">차량 이용 대수</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationListData('vehicleCnt')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">요청사항</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationListData('customerComment')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">차량 옵션</span>
      </v-col>
      <v-col cols="12" md="4" sm="6" >
        <span>{{getReservationListData('vehicleOption')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">차종</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{ getReservationListData('vehicleType') }}</span>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" sm="6" md="2">
        <span class="font-weight-black">시내/시외</span>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <span>{{ suburbanString }}{{ fareDetailString }}</span>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <span
          class="font-weight-black"
          v-if="checkReservationState(reservationRouteLists) !== 'rs_cancel' && checkReservationState(reservationRouteLists) !== 'rs_user_cancel'"
        >
          <c-btn outlined color="indigo" small @click="updatePassengerDialog = true">탑승인원변경</c-btn>
        </span>
      </v-col>
      <v-col cols="12" sm="6" md="4"></v-col>
    </v-row>
    <v-row v-for="(item, index) in getReservationListData('reservationRouteList')" :key="index">
      <v-col cols="12" md="2" sm="6" class="align-self-center">
        <span v-if="item.seq === 0" class="font-weight-black">출발지</span>
        <span v-else-if="item.seq > 1" class="font-weight-black">경유지{{item.seq - 1}}</span>
        <span v-else-if="item.seq === 1" class="font-weight-black">도착지</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <div>{{item.position}}</div>
        <div>{{item.comment}}</div>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <div class="d-flex">
          <div :class="`${item.seq === 1 ? '' : 'font-weight-black'}`">탑승</div>
          <div v-if="item.seq !== 1" class="ml-2">{{item.onCnt}}명</div>
          <div v-else class="ml-3">-</div>
        </div>

        <div class="d-flex">
          <div :class="`${item.seq === 0 ? '' : 'font-weight-black'}`">하차</div>
          <div v-if="item.seq !== 0" class="ml-2">{{item.offCnt}}명</div>
          <div v-else class="ml-3">-</div>
        </div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" md="2" sm="6" class="align-self-center">
        <span class="font-weight-black">예약 진행 상황</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <c-reservation-state-chip
          :reservation="existReservationData"
          :reservationStateEventFlag="reservationStateEventFlag"
          @onChangeReservationState="onChangeReservationState"
          @onReReservation="onReReservation"
        />
      </v-col>
      <template v-if="checkReservationState(reservationRouteLists) === 'rs_cancel' || checkReservationState(reservationRouteLists) === 'rs_user_cancel'" >
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">취소 시각</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ getReservationListData('created')}}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">취소 사유</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ getReservationListData('cancelComment') ? '일정 변경 및 취소' : '-' }}</span>
        </v-col>
      </template>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">배정 기사</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <div v-for="item in getReservationListData('driverId')">
          <span style="cursor: pointer" @click="item ? $route.path !== `/drivers/${item.id}` ? $router.push(`/drivers/${item.id}`) : '' : ''">
            {{ item ? item.name : '-' }}
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">배정 차량</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <div v-for="item in getReservationListData('vehicleId')">{{ item ? ( (item.plateNo||'') + ' | ' +
          (item.modelName||'')) : '-' }}
        </div>
      </v-col>
    </v-row>

    <!--수동배차 dialog-->
    <manual-reserve-dialog
      :open.sync="manualDialogOpen"
      :reservationCheckData.sync="reservationData"
      :reservationFlag.sync="manualReservationFlag"
    ></manual-reserve-dialog>

    <!--자동배차 loading bar-->
    <v-dialog
      v-model="autoDialogOpen"
      hide-overlay
      persistent
      width="300"
    >
      <c-card
        class="blue"
      >
        <v-card-text>
          <div class="py-6 text-center white--text">
            자동 배차 중입니다.
          </div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
            height="10"
          ></v-progress-linear>
        </v-card-text>
      </c-card>
    </v-dialog>

    <time-recommend-dialog
        :open.sync="timeRecoDialogFlag"
        :reservation-id="autoReservationId"
        :fail-time="failTime"
        :available-time-list="availableTimeList"
        @reqAutoReservation="reqAutoReservation"
    />

    <v-dialog v-if="updatePassengerDialog" v-model="updatePassengerDialog" max-width="800px">
      <c-card class="white">
        <v-card-title>탑승 인원 변경</v-card-title>
        <passenger-update-form
            :passenger-count="passengerList && passengerList.length"
            :reservation-route-list="reservationRouteLists.length > 0 ? reservationRouteLists[0].reservationRouteList : []"
            :passengerDataList.sync="passengerDataList"
        />
        <v-row justify="center" class="mt-10">
          <c-btn class="mr-1" color="blue" outlined @click="updateReservationPassengerCount">수정</c-btn>
          <c-btn color="gray" outlined @click="updatePassengerDialog = false">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

    <v-dialog v-if="helpServiceFormDialog" v-model="helpServiceFormDialog" max-width="600px">
      <c-card class="white">
        <v-card-title class="mb-5">도움 서비스 정보 입력</v-card-title>
        <v-radio-group v-model="helpServiceFormData.isMatching" row class="ma-0" label="동행 매니저">
          <v-radio label="미배정" :value="false"></v-radio>
          <v-radio label="배정" :value="true"></v-radio>
        </v-radio-group>
        <v-col>
          <span class="ml-1">동행 매니저 이름</span>
          <v-text-field class="my-3" v-model="helpServiceFormData.managerName" placeholder="이름을 입력해주세요"
                        solo dense required :rules="[v => !!v]" maxLength="32"
                        hide-details color="navy" maxlength="32"/>
        </v-col>
        <v-col>
          <span class="ml-1 mb-2">동행 매니저 연락처</span>
          <v-row justify="space-around" align="center">
            <v-col cols="3" class="mr-0 pr-0">
              <v-text-field v-model="helpServiceFormData.mobileNo1" v-mask="['##','###']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
            </v-col>
            <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
            <v-col cols="3" class="mx-0 px-0">
              <v-text-field id="mobileNo2C" v-model="helpServiceFormData.mobileNo2" v-mask="['###','####']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
            </v-col>
            <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
            <v-col cols="3" class="ml-0 pl-0">
              <v-text-field id="mobileNo3C" v-model="helpServiceFormData.mobileNo3" v-mask="['####']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-row justify="center">
          <c-btn @click="onRegisterHelpManager" outlined color="primary">저장</c-btn>
          <c-btn @click="helpServiceFormDialog = false" class="ml-1" outlined>취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

  </v-container>
</template>
<script>
  import ManualReserveDialog from '../../CallTaxi/Reserve/ManualReserveDialog';
  import {mask} from 'vue-the-mask';
  import TimeRecommendDialog from "@/views/CallTaxi/Reserve/TimeRecommendDialog";
  import CReservationStateChip from "@/components/CReservationStateChip.vue";
  import PassengerUpdateForm from "@/views/CallTaxi/Reserve/PassengerUpdateForm.vue";

  export default {
    components: {CReservationStateChip, ManualReserveDialog,TimeRecommendDialog, PassengerUpdateForm},

    directives: {mask},
    data: () => ({
      maskMobileNo: '010-####-####',

      resrvColor: '',
      vehicleModel: '',
      vehicleTypeList: [],
      driverList: [],

      manualDialogOpen: false,
      autoDialogOpen: false,
      reservationId: null,
      reservationRouteLists : [],
      passengerList:[],
      passengerTableHeaders:[
          {text:'No.', value:'idx', align:'center', sortable:false},
          {text:'이름', value:'customerName', align:'center', sortable:false},
          {text:'연락처', value:'customerNo', align:'center', sortable:false},
          {text:'회원 유형', value:'customerType', align:'center', sortable:false},
          {text:'비고', value:'etc', align:'center', sortable:false},
          {text:'용도', value:'usages', align:'center', sortable:false},
          {text:'수하물', value:'luggage', align:'center', sortable:false},
          {text:'상세보기', value:'detail', align:'center', sortable:false},
      ],
      passengerListItems:[],
      booker:{},
      manualReservationFlag: null,

      timeRecoDialogFlag: false,
      autoReservationId: '',
      autoReservationFlag: false,
      availableTimeList: [],
      failTime: '',
      updatePassengerDialog: false,
      passengerDataList: [],
      helpServiceFormDialog: false,
      helpServiceFormData: {
        isMatching: false,
        managerName: '',
        mobileNo1: '',
        mobileNo2: '',
        mobileNo3: '',
      }
    }),
    props: {
      reservationEditableFlag: {
        type: Boolean,
      },
      reservationStateEventFlag: {
        type: Boolean,
      },
      reservationData: {
        type: Object | Array,
        default: {}
      },
      customerData: {
        type: Object,
      },
      canceledFlag: {
        type: Boolean,
        default: false
      },
      couponInfo: {
        type: String,
        default: '',
      }
    },
    watch:{
      canceledResrvId(val) {
        this.$router.push(`/canceledReservation/${val}`);
      },
      reservationData: {
        immediate:true,
        deep:true,
        handler(val) {
          if(!!val && (!!(val.reservationList || val.canceledReservationList) && !!val.passengerList) ) {
            this.passengerListItems = [];

            this.reservationRouteLists = val.reservationList ? val.reservationList : val.canceledReservationList;
            this.passengerList = val.passengerList;
            for(let idx in this.passengerList) {
              const item = this.passengerList[idx];
              if(item.passengerType === 'BOOKER') {
                this.booker = item;
              } else {
                this.passengerListItems.push(item);
              }
            }

            this.passengerListItems.map((item, idx) => {
              let newItem = {...item};
              item.idx = idx + 1;
              return newItem
            });
          }
        }
      },
      manualReservationFlag(newVal) {
        if (newVal && newVal === 'success') {
          this.$emit("reloadReservation");
          this.manualReservationFlag = null;
        }
      },
    },
    computed: {
      createdCheck() {
        const reservationData = this.reservationRouteLists[0];
        if (reservationData) {
          const result = (!reservationData.reservationCreated || this.canceledFlag) ? reservationData.reservationCreated : reservationData.created;
          return !!result ? this.$func.dateTimeToString(result) : this.$func.dateTimeToString(reservationData.created);
        }
      },
      existReservationData() {
        return this.reservationRouteLists?.length ? this.reservationRouteLists[0] : undefined;
      },
      isBreakTime() {
        const reservationData = this.reservationRouteLists;
        return reservationData && reservationData[0] && reservationData[0].departure === '휴식' && reservationData[0].destination === '휴식';
      },
      changeReservationInfoFlag() {
        const reservationEditableFlag = this.reservationEditableFlag;
        const reservationData = this.reservationRouteLists;

        return reservationEditableFlag && reservationData && reservationData[0]
          && !(reservationData[0].customerName === reservationData[0].departure && reservationData[0].customerName === reservationData[0].destination)
          && (reservationData[0].resrvState.configValue === 'rs_complete'
            || reservationData[0].resrvState.configValue === 'rs_receipt');
      },
      changeReservationStateFlag() {
        const reservationStateEventFlag = this.reservationStateEventFlag;
        const reservationData = this.reservationRouteLists;

        return reservationStateEventFlag && reservationData && reservationData[0]
          && (reservationData[0].resrvState.configValue === 'rs_complete'
            || reservationData[0].resrvState.configValue === 'rs_cancel'
            || reservationData[0].resrvState.configValue === 'rs_user_cancel');
      },
      suburbanString() {
        const reservationData = this.reservationRouteLists[0];
        if (!reservationData || !reservationData.fareType) return ''

        return reservationData.fareType.startsWith('suburban') ? '시외' : '시내'
      },
      fareDetailString() {
        const reservationData = this.reservationRouteLists[0];
        if (!reservationData || !reservationData.fareType) return ''

        const fareType = reservationData.fareType;
        const isAreaType = fareType.includes('_area') || fareType.includes('_at')
        return isAreaType ? ` (${reservationData.fareDetail})` : ''
      },
      familyContactList() {
        const familyContactRelationList =
            [
              {text: '가족', value:'가족'},
              {text: '친구, 지인', value:'친구,지인'},
              {text: '복지사', value:'복지사'},
              {text: '기타', value:'기타'}
            ];
        let familyContactList = this.booker.customer.familyContactList;
        try {
          if(familyContactList) {
            familyContactList = JSON.parse(familyContactList);

            return familyContactList.map(contact => {
              let relation = familyContactRelationList.find(item => item.value === contact.relation);
              // familyContactRelationList 이외에 이전에 입력한 관계정보를 detail화면에서 표시는 해줌.
              relation = relation ? relation.text : contact.relation;
              return contact.phone + ' ' + relation;
            }).join('<br/>');
          }
        } catch(e) {
          console.error('fail familyContactList parsing : ', e)
        }
        return '';
      },
      priorityOfContactList(){
        if(this.getReservationListData('familyNo') != null && this.getReservationListData('familyRelation') != null && this.getReservationListData('familyNo').length != 0 && this.getReservationListData('familyRelation').length != 0){
          return this.getReservationListData('familyNo') + " " + this.getReservationListData('familyRelation');
        } else if(this.booker.customerType!=null && this.booker.customer.familyContactList!=null) {
          return this.familyContactList;
        } else {
          return "-";
        }
      }
    },
    methods: {
      getEtcInfo(passenger) {
        if(!passenger) {
            return "";
        }

        const {customerType, pregnantInfo, mobilityWeakInfo} = passenger;
        if (customerType && customerType.configValue === 'ct_pregnant' && pregnantInfo) {
            return pregnantInfo.expectedDeliveryDate + " 출산예정";

        } else if (customerType && customerType.configValue === 'ct_mobility_week' && mobilityWeakInfo) {
            const {handicapInfo, wheelchair} = mobilityWeakInfo;
            let displayText = "";

            const handicapArr = JSON.parse(handicapInfo);
            displayText = handicapArr.map(handicap => {
                const {type, degree} = handicap;
                return type+'('+degree+')';
            }).join();

            if (wheelchair !== '없음') {
               displayText += '/' + wheelchair + "휠체어";
            }

            return displayText;
        }

        return "";
      },
      showCustomerType(customerType) {
        if(customerType === null) {
          return '일반';
        } else if(customerType.configValue === 'ct_normal' || customerType.configValue === 'ct_guardian') {
          return customerType.configName;
        } else {
          return '교통약자 ('+ customerType.configName + ')';
        }
      },
      onChangeReservationState(state) {
        this.$emit('changeReservationState', state);
      },
      getReservationListData(key) {
        if (this.reservationRouteLists !== null && this.reservationRouteLists.length > 0) {
          let data = this.reservationRouteLists[0][key];
          if (key === 'created' || key === 'startTime' || key === 'endTime') {
            data = this.$func.dateTimeToString(data);
          } else if (key === 'driveTime' ) {
            data= this.$func.msToTimeFormat(data);
          } else if (key === 'driverId') {
            data = this.reservationRouteLists.map(item => item.driver);
          } else if (key === 'vehicleId') {
            data = this.reservationRouteLists.map((item) => item.vehicle);
          } else if (key === 'managerName') {
            let managerPhoneNo = this.reservationRouteLists[0].managerPhoneNo
            data = data || managerPhoneNo
                ? `${data ?? '-'}(${managerPhoneNo ?? '-'})`
                : '-'
          } else if (key === 'vehicleType') {
            let vehicleType = [];
            let types = data.split(',');

            for (const i in types) {
              let vehicle = types[i];
              if (vehicle === 'c_11seat') {
                vehicleType.push('11인승');
              }
              if (vehicle === 'c_15seat') {
                vehicleType.push('15인승');
              }
              if (vehicle === 'c_5seat') {
                vehicleType.push('승용차');
              }
              if (vehicle === 'c_9seat') {
                vehicleType.push('9인승');
              }
              if (vehicle === 'c_12seat') {
                vehicleType.push('12인승');
              }
              if (vehicle === 'c_7seat') {
                vehicleType.push('7인승');
              }
              if (vehicle === 'c_6seat') {
                vehicleType.push('6인승');
              }
              if(vehicle === 'c_14seat') {
                vehicleType.push('14인승');
              } 
              if(vehicle === 'c_5seat2') {
                vehicleType.push('5인승');
              }
            }
            data = vehicleType.toString();
          } else if (key === 'vehicleOption') {
            let vehicleOption = [];
            let options = data ? data.split(',') : [];

            if(options.length > 0) {
              options.forEach((option) => {
                if (option === 'c_wcl'){
                  vehicleOption.push("휠체어 리프트");
                } else if(option === 'c_all') {
                  vehicleOption.push("모두 선택");
                } else {
                  vehicleOption.push("없음");
                }
              });
            } else{
              vehicleOption.push("없음")
            }
            data = vehicleOption.toString();
          }else if(key === 'reservationRouteList'){
            data = this.reservationRouteLists[0].reservationRouteList;
          }
          return data;
        } else {
          return '';
        }
      },
      async reqReservationWithPassengers() {
        try {
          const res = await this.$api.getReservationWithPassengers(this.reservationId);
          this.reservationData = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqReservationWithPassengers'});
        }
      },

      async reqAutoReservation(rId, startTime) {
        this.autoDialogOpen = true;
        let reqData = {
          reservationId: rId,
          startTime: startTime,
          centerId: this.$store.state.centerInfo.centerId
        };

        try {
          const { data } = await this.$api.autoReservation(reqData);
          const { isAssignSuccess, reservableList } = data;

          if(!isAssignSuccess) {
            // 가능한 시간이 없을 경우
            if (reservableList.length < 1) {
              this.$store.commit('alert',
                  {
                    err: true, where: 'reqAutoReservation',
                    open: true, persistent: true,
                    msg: '배차 가능한 차량이 없습니다.\n' +
                        '예약시간을 확인해 주세요.'
                  });
              this.autoDialogOpen = false;
              return;
            }

            // 가능한 시간 팝업
            this.autoDialogOpen = false;
            this.autoReservationId = rId;
            this.failTime = startTime;
            this.availableTimeList = reservableList.map(item => {
              let newItem = {};
              newItem.text = this.$moment(item.date).format('HH:mm');
              newItem.value = item.date;
              return newItem;
            });
            this.timeRecoDialogFlag = true;
          } else {
            this.$store.commit('snackbar', {color: 'blue', timeout: 2000, msg: '예약이 완료되었습니다.'});

            this.autoDialogOpen = false;
            this.timeRecoDialogFlag = false;

            await this.$emit('reloadReservation');

          }

        } catch (err) {
          this.autoDialogOpen = false;
          this.$store.commit('alert',
            {
              err, where: 'reqAutoReservation',
              open: true, persistent: true, msg: "자동배차에 실패했습니다.",
            });
        }
      },
      async onReReservation(type) {
        const { reservationList } = this.reservationData;
        const startTime = reservationList[0].startTime;
        if (type === 'auto') {
          if (this.$moment(startTime).isBefore(this.$moment())) {
            return this.$store.commit('snackbar', {msg: '과거 시간은 자동배차가 불가능합니다.'});
          }
          await this.reqAutoReservation(this.reservationId, startTime);
        } else {
          await this.reqReservationWithPassengers(this.reservationId);
          this.manualDialogOpen = true;
        }
      },
      checkReservationState(reservationData) {
        if (!reservationData || !reservationData[0] || !reservationData[0].resrvState)
          return;
        return reservationData[0].resrvState.configValue;
      },
      async updateReservationPassengerCount() {
        const res = await this.$api.checkEnableReservation(this.reservationId);
        if (!res.data) {
          this.$store.commit('alert',
              {
                open: true, persistent: true, msg: "이용중 상태의 예약정보는 변경할 수 없습니다.",
                info: true
              });
          return;
        }

        const data = this.passengerDataList.map(route => ({
          seq: route.seq,
          onCnt: route.onCnt,
          offCnt: route.offCnt
        }));

        const onCntSum = this.passengerDataList.reduce((acc, value) => (acc + value.onCnt), 0)
        const offCntSum = this.passengerDataList.reduce((acc, value) => (acc + value.offCnt), 0)

        try {
          if (this.passengerList.length === onCntSum
              && this.passengerList.length === offCntSum) {
            await this.$api.updateReservationPassengerCount(this.reservationId, data)
            this.updatePassengerOnOffCnt()
            this.updatePassengerDialog = false;
          } else if (this.passengerList.length !== onCntSum) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '탑승 인원의 합을 '+this.passengerList.length+' 명으로 변경해 주세요.'});
          } else if (this.passengerList.length !== offCntSum) {
            this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '하차 인원의 합을 '+this.passengerList.length+' 명으로 변경해 주세요.'});
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'updateReservationPassengerCount', msg: '문제가 발생하였습니다. 잠시후 다시 시도해주세요.'});
        }
        if(this.passengerList.length !== onCntSum && this.passengerList.length !== offCntSum) {
           this.$store.commit('snackbar', {where: 'makeReqReservationData', msg: '탑승, 하차 인원의 합을 '+this.passengerList.length+' 명으로 변경해 주세요.'});
        }
      },
      updatePassengerOnOffCnt() {
        this.reservationRouteLists[0].reservationRouteList = this.reservationRouteLists[0].reservationRouteList.map(item => {
          const passengerData = this.passengerDataList.find(data => data.seq === item.seq)

          return {
            ...item,
            onCnt: passengerData.onCnt,
            offCnt: passengerData.offCnt
          }
        })
      },
      openHelpServiceDialog() {
        if (this.reservationData?.reservationList?.length > 0) {
          const { isMatching, managerName, managerPhoneNo } = this.reservationData.reservationList[0]
          this.helpServiceFormData.isMatching = isMatching
          this.helpServiceFormData.managerName = managerName;
          [this.helpServiceFormData.mobileNo1, this.helpServiceFormData.mobileNo2, this.helpServiceFormData.mobileNo3] = managerPhoneNo?.split('-') ?? ['', '', '']
        }
        this.helpServiceFormDialog = true
      },
      async onRegisterHelpManager() {
        let managerPhoneNo = ''
        if (this.helpServiceFormData.mobileNo1 || this.helpServiceFormData.mobileNo2 || this.helpServiceFormData.mobileNo3) {
          managerPhoneNo = this.helpServiceFormData.mobileNo1 + '-' + this.helpServiceFormData.mobileNo2 + '-' + this.helpServiceFormData.mobileNo3
        }

        const params = {
          isMatching: this.helpServiceFormData.isMatching,
          managerName: this.helpServiceFormData.managerName,
          managerPhoneNo: managerPhoneNo
        }
        await this.$api.addHelpServiceManager(this.reservationId, params)
        this.$emit("reloadReservation");
        this.helpServiceFormDialog = false
      }
    },
    mounted() {
      const {reservationId} = this.$route.params;
      this.reservationId = reservationId;
    },
  }
</script>
<style scoped>
  .waypoint {
    margin-top: 3px;
  }

  .infoEditTextField {
    font-size: 15px;
    font-weight: bold;
  }
</style>